export default __webpack_public_path__ + "static/media/pointerBlue.040a51ec.png";